import React from 'react'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Terms from '../../containers/Terms'

const TermsPage = ({ isNew }) => {
  return (
    <>
      <Terms isNew={isNew} />
    </>
  )
}

export const getServerSideProps = async ({ locale, query }) => ({
  props: {
    isNew: !('old' in query),
    ...(await serverSideTranslations(locale, [
      'common',
      'header',
      'footer',
      'pdpa',
    ])),
  },
})

export default TermsPage
